import { useState, useEffect } from 'react'
import "../css/ComponentStyle.css";
import { useNavigate, useLocation } from 'react-router'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHouseChimney, faTimes } from '@fortawesome/free-solid-svg-icons'
import { useSelector } from 'react-redux';

const Sidebar = ({ isSidebarOpen, toggleSidebar }) => {

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [activePage, setActivePage] = useState("");
  const DemoGraphyData = useSelector((state) => state.user.demoDetails);


  useEffect(() => {
    if (DemoGraphyData) {
      setLoading(false);
    }
  }, [DemoGraphyData]);

  const PatientID = DemoGraphyData?.PatientId;

  // const userData = useSelector((state) => state.user.user);



  // var userPracticeID = userData ? userData.practiceID : null;

  // var userId = userData ? userData.userID : null;



  const updateActivePage = () => {
    const currentHash = window.location.hash.replace("/#/", "").replace("#/", "");
    setActivePage(currentHash || "BillingDashboard");
    localStorage.setItem("activePage", currentHash || "BillingDashboard");
  };

  useEffect(() => {

    updateActivePage();


    window.addEventListener("hashchange", updateActivePage);

    return () => {
      window.removeEventListener("hashchange", updateActivePage);
    };
  }, []);

  const handleMenuClick = (pageName) => {
    window.open(`/#/${pageName}`, "_blank");
    // navigate(`/${pageName}`)
  };



  const handleClick = (pageName) => {

    const newActivePage = `/${pageName}/${PatientID}`;

    localStorage.setItem("activePage", newActivePage);
    setActivePage(newActivePage);
    navigate(newActivePage);
  }




  const handleTabClick = (pageName) => {

    const newActivePage = `/${pageName}/${PatientID}/primary-insurance`;

    localStorage.setItem("activePage", newActivePage);
    setActivePage(newActivePage);
    navigate(newActivePage);
  }

  const handleDMClick = (pageName) => {

    const newActivePage = `/${pageName}/${PatientID}/Personal-info`;

    localStorage.setItem("activePage", newActivePage);
    setActivePage(newActivePage);
    navigate(newActivePage);
  }






  const location = useLocation();


  const isLoginPage = location.pathname === '/';

  if (isLoginPage) {
    return null;
  }



  const isLocPage = location.pathname === '/locations';

  if (isLocPage) {
    return null;
  }


  const isPatDashPage = location.pathname === '/patient-dashboard/biller-dashboard/:id';

  if (isPatDashPage) {
    return null;
  }



  return (
    <>
      <div className={`sidebar-container ${isSidebarOpen ? "show-sidebar" : "hide-sidebar"}`}>
        <div className="sidebar">
          <button className="close-btn" onClick={toggleSidebar}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
          <div className="logo"></div>



          {loading && (
            <div className="overlay">
              <div className="spinner-container">
                <div className="spinner-grow text-danger" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <div className="spinner-grow text-warning" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <div className="spinner-grow text-info" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            </div>
          )}

          {DemoGraphyData && DemoGraphyData.MRN ? (

            <ul className="nav-links">
              <div className="logo">
                <FontAwesomeIcon onClick={() => handleMenuClick('Billingdasboard')} icon={faHouseChimney} style={{ marginLeft: '10px' }} />
              </div>

              <li className={activePage.includes("PatientContacts") ? "active-record" : "menu"} onClick={() => handleDMClick('PatientContacts')}>DM</li>
              <li className={activePage.includes("GeneralDocuments") ? "active-record" : "menu"} onClick={() => handleClick('GeneralDocuments')}>GENERAL DOC</li>
              <li className={activePage.includes("patient-insurance") ? "active-record" : "menu"} onClick={() => handleTabClick('patient-insurance')}>Insurance</li>


            </ul>
          ) : (
            <>

              <ul className="nav-links">

                <li className={` ${activePage === 'Billingdasboard' ? 'active-record' : ''}`} onClick={() => handleMenuClick('Billingdasboard')}>Home</li>
                <li className={` ${activePage === 'IntelliBill' ? 'active-record' : ''}`} onClick={() => handleMenuClick('IntelliBill')}>Intelli Bill</li>
                <li className={` ${activePage === 'LabBilling' ? 'active-record' : ''}`} onClick={() => handleMenuClick('LabBilling')}>Lab Billing</li>
                <li className={` ${activePage === 'Claimapproval' ? 'active-record' : ''}`} onClick={() => handleMenuClick('Claimapproval')}>Approval</li>
                <li className={` ${activePage === 'MedicalClaimStatus' ? 'active-record' : ''}`} onClick={() => handleMenuClick('MedicalClaimStatus')}>Claim Status</li>
                <li className={` ${activePage === 'new-encounter' ? 'active-record' : ''}`} onClick={() => handleMenuClick('new-encounter')}>New Encounter</li>
                <li className={` ${activePage === 'PostingPayments' ? 'active-record' : ''}`} onClick={() => handleMenuClick('PostingPayments')}>Posting Payments</li>
                <li className={` ${activePage === 'UpdateCPT' ? 'active-record' : ''}`} onClick={() => handleMenuClick('UpdateCPT')}>Edit CPT</li>
                <li className={` ${activePage === 'InsurancePaymentReport' ? 'active-record' : ''}`} onClick={() => handleMenuClick('InsurancePaymentReport')}>Insurance Payment Report</li>
                <li className={` ${activePage === 'workableclaims' ? 'active-record' : ''}`} onClick={() => handleMenuClick('workableclaims')}>Workable Claims</li>
                <li className={` ${activePage === 'MedicalClaimMacro' ? 'active-record' : ''}`} onClick={() => handleMenuClick('MedicalClaimMacro')}>Macro</li>
                <li className={` ${activePage === 'Upload-RemittanceFiles' ? 'active-record' : ''}`} onClick={() => handleMenuClick('Upload-RemittanceFiles')}>Remittance Upload</li>
                <li className={` ${activePage === 'superbill' ? 'active-record' : ''}`} onClick={() => handleMenuClick('superbill')}>Superbill</li>
                <li className={` ${activePage === 'BillerPatientTracker' ? 'active-record' : ''}`} onClick={() => handleMenuClick('BillerPatientTracker')}>Patient Tracker</li>


              </ul>



            </>
          )}
        </div>


      </div>
    </>
  )
}

export default Sidebar